module.exports = __webpack_public_path__ + "84f997eaa9bebbf622a6809f1919ca01.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/red_bull.png
// module id = 643
// module chunks = 0